import { Component, OnInit, ViewChild } from "@angular/core";
import { PedidoService } from "src/app/core/services/pedido-service";
import { Order } from "src/app/core/entities/order";
import { FormGroup, Validators, FormBuilder } from "@angular/forms";
import { Router } from "@angular/router";
import Swal from "sweetalert2";
import { Configuracoes } from "src/app/core/entities/configuracoes";
import { ProductService } from "src/app/core/services/product-service";
import { FreteService } from "src/app/core/services/frete-service";
import { ConfiguracoesSite } from "src/app/core/entities/configuracoesSite";
import { UsuarioService } from "src/app/core/services/usuario-service";
import { ToastrService } from "ngx-toastr";
import { InitProvider } from "src/app/core/services/init-provider";
import { CurrencyPipe } from "@angular/common";
import { LogService } from "src/app/core/services/log-service";
import { OrderItem } from "src/app/core/entities/orderItem";
import { DomSanitizer } from "@angular/platform-browser";
import { Location } from "@angular/common";
import { SecurityService } from "src/app/core/services/security-service";
import { Frete, FreteApiType } from "src/app/core/entities/Frete";
import {
  trigger,
  state,
  style,
  animate,
  transition,
} from "@angular/animations";
import "@angular/localize/init";
import { CreditCardComponent } from "src/app/components/credit-card/credit-card.component";
declare var $: any;

@Component({
  selector: "app-page-checkout",
  templateUrl: "./page-checkout.component.html",
  styleUrls: ["./page-checkout.component.css"],
  animations: [
    trigger("expandCollapse", [
      state("expanded", style({ height: "*", opacity: 1 })),
      state("collapsed", style({ height: "0px", visibility: "collapse" })),
      transition("expanded <=> collapsed", [animate("300ms ease-in-out")]),
    ]),
  ],
})
export class PageCheckoutComponent implements OnInit {
  @ViewChild("formComp") formComp!: CreditCardComponent;
  SITE: ConfiguracoesSite;
  public modo = 1;
  public valorMinimoPedido = 0;
  public error: Boolean = false;
  public permiteDesconto: Boolean = false;
  public maxDesconto: number = 99;
  public imposto: any = {};
  public retirar: Boolean = false;
  public qtdMinimaItens: number = 4
  public firstOpen = false;
  public QtdPedidoClienteSelected: number = 0;
  public errorMsg: String;
  public worningMessage: String;
  public cupom: String = "";
  public idCupom: any = "";
  public cupomAplicado: String = "";
  public descontoCupom: number = 0;
  public form: FormGroup;
  public API_IMAGENS: String;
  public API_IMAGENS_PRODUTOS: String;
  public pedidoItensPrecoSumComImp = 0;
  public formaPagamento: any = [];
  public pedidoClientes = [];
  public pedidoItens = [];
  public pedidoItensQuantSum = 0;
  public pedidoItensPrecoSum = 0;
  public pedidoClienteSelected;
  public pedido: Order;
  public mapClientes;
  public countPCDescFilial: number = 0;
  public countPCAcresFilial: number = 0;
  public loadingUpload: boolean = false;
  public subTotal: number = 0;
  public valorTotal: number = 0;
  public acrescimoTotal: number = 0;
  public descontoFormaPagamento: number = 0;
  public descontoPedido: number = 12;
  public impostosTotal: number = 0;
  public impostos = [];
  public itens = [];
  public checkErrorEstoqueBool = false;
  public fretes: FreteApiType = { receber: [], retirar: [] };
  public files = [];
  public tipoFrete: number = 0;
  public freteOferta;
  public freteToken;
  public uploadFile;
  public freteShow = false;
  public freteSalvoDescr;
  pedidoTiposUsuario: any = [];
  filiais: any = [];
  public pedidoFilial;
  private currencyPipe: CurrencyPipe = new CurrencyPipe("pt-BR");
  public fatalError = false;
  public selectedCliente;
  public clienteIdErp;
  public descontoMaximo;
  public showFreteSum = false;
  public errorFrete = false;
  expand: boolean = true;
  public freteCepDestino = "";
  public currentFormaPagamento;
  public currentTipoPagamento;
  public limiteCredito;
  public limiteDisponivel;
  public limiteValido;
  public idDelete;
  public idPedidoDelete;
  public idDeleteModo2;
  public tipoPagamento = [];
  public filtrados = [];
  public calculando: boolean = false;
  public usaTipoPedido;
  cifPermited = false;
  fobPermited = false;
  qrCode: any = {};
  bloqueiaPedidos;
  stringLocale: string = $localize`pt-BR`;
  descontoPercent: number = 0;
  freteValor = 0;
  qtdMaxGrade: any;
  descontoAplicado: number = 0;
  tempDiscount: number = 0;
  private descontoManualAplicado = false;
  private cupomPercentualAplicado = false;
  public loadSubmit = false;

  toRoute(modo) {
    this.modo = modo;
    window.localStorage.setItem("checkoutModo", modo);
    this.atualizaPedidoItens();
  }

  expandTable() {
    this.expand = !this.expand;
    localStorage.setItem(
      "tabelaItensCheckoutExpand",
      JSON.stringify(this.expand)
    );
  }

  get descontoItens(): number {
    return this.pedidoItens.reduce(
      (acc, item) => acc + (item.desconto_item || 0),
      0
    );
  }

  get percentualDesconto(): number {
    if (!this.subTotal) return 0;
    return (this.descontoItens / this.subTotal) * 100;
  }
  onSelectedFile(e) {
    if (!e.target.files[0]) {
      Swal.fire(
        $localize`Arquivo`,
        $localize`Informe um arquivo corretamente.`,
        "warning"
      );
      return;
    }
    let file = e.target.files[0];
    if (file.size > 2048000) {
      Swal.fire(
        $localize`Arquivo`,
        $localize`Tamanho total dos arquivo superior a 2mb. Insira um arquivo menor`,
        "warning"
      );
      return;
    }

    //Upload de arquivos pdfs, requerido, concatenação utilizada
    if (this.uploadFile == 1) {
      let ext = file.name.split(".")[1].toLowerCase();
      if ("pdf" === ext) {
        this.files.push(file);
        return;
      }
      Swal.fire(
        $localize`Arquivo`,
        $localize`Este arquivo selecionado não é do tipo PDF.`,
        "warning"
      );
    }
  }

  onRemoveFile(index) {
    this.files.splice(index, 1);
  }

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    public pedidoService: PedidoService,
    private usuarioService: UsuarioService,
    private freteService: FreteService,
    private productService: ProductService,
    private initProvider: InitProvider,
    private toastService: ToastrService,
    private sanitizer: DomSanitizer,
    public securityService: SecurityService,
    private location: Location,
    private logService: LogService
  ) {
    if (localStorage.getItem("tabelaItensCheckoutExpand") !== null) {
      this.expand = JSON.parse(
        localStorage.getItem("tabelaItensCheckoutExpand")
      );
    }
    if (this.securityService.isPainel()) {
      this.location.back();
    }
    this.SITE = Configuracoes.SITE;
    this.API_IMAGENS = Configuracoes.API_IMAGENS;
    this.qtdMaxGrade = this.SITE.quantidadeMaximaGrade;
    this.API_IMAGENS_PRODUTOS = Configuracoes.API_IMAGENS_PRODUTOS;

    if (!this.pedidoService.pedido) {
      return;
    }
    // this.filiais = initProvider.filiais;
    // this.usuarioService.getFiliais(cliente.filial_cliente, (e) => this.filiais = e);
    this.usuarioService.getClientesId(
      { id_cliente: this.pedidoService.pedido.clientes[0].cliente.id },
      (resp) => {
        this.descontoMaximo = resp.desconto_maximo;
        this.filiais = resp.filiais;
        this.limiteCredito = resp.limite_credito;
        this.limiteDisponivel = resp.limite_disponivel;
        this.limiteValido = resp.limite_valido;
        this.bloqueiaPedidos = resp.bloqueiaPedidos;
        if (
          this.limiteDisponivel <= this.valorTotal &&
          this.limiteDisponivel !== null
        ) {
          this.toastService.error(
            $localize`Seu limite de crédito disponível é R$ ${this.limiteDisponivel.toLocaleString(
              "pt-BR",
              {
                style: "currency",
                currency: "BRL",
              }
            )} .`,
            $localize`Aprovação Pedido`
          );
          return;
        }
        if (!this.limiteValido && this.limiteCredito !== null) {
          this.toastService.error(
            $localize`Limite de crédito fora do prazo de validade`,
            $localize`Aprovação Pedido`
          );
          return;
        }
      }
    );
    this.usuarioService.getTipoPagamento(
      this.pedidoService.pedido.clientes[0].cliente.id,
      (e) => {
        this.tipoPagamento = e;
      }
    );

    this.usaTipoPedido = this.initProvider.usaTipoPedido;

    let checkoutModo = parseInt(window.localStorage.getItem("checkoutModo"));
    if (checkoutModo) {
      this.modo = checkoutModo;
    }
    this.imposto = this.pedidoService.pedido.imposto;
    this.notify(this.pedidoService.pedido);
  }
  ngOnInit(): void {
    if (this.pedido !== undefined) {
      this.pedidoService.getPedidoId(this.pedido.id, (e) => {
        this.pedidoService.select(e);
        this.notify(this.pedidoService.pedido);
        this.imposto = this.pedidoService.pedido.imposto;
        this.filtrados = e.clientes;
        this.valorMinimoPedido = e.pedido_minimo ? e.pedido_minimo : 0;
        this.QtdPedidoClienteSelected = this.pedido.clientes.length;
        if (this.pedido.clientes.length === 1) {
          this.permiteDesconto = this.pedido.clientes[0].permite_desconto;
          this.form.controls.formaPagamento.enable();
        } else {
          this.form.controls.formaPagamento.disable();
        }
        if (this.pedido.tipo.tipoFrete === 0) {
          this.form.controls.formaPagamento.enable();
        }
      });
    }
  }

  removeItem() {
    if (!this.idDelete) return;
    this.pedidoService.removeCartItem(
      this.idDelete,
      function (resp) {
        this.pedidoService.getPedidoId(this.pedido.id, (e) => {
          this.pedidoService.select(e);
          this.notify(this.pedidoService.pedido);
          this.imposto = this.pedidoService.pedido.imposto;
          this.filtrados = e.clientes;
          this.valorMinimoPedido = e.pedido_minimo ? e.pedido_minimo : 0;
          this.QtdPedidoClienteSelected = this.pedido.clientes.length;
          if (this.pedido.clientes.length === 1) {
            this.permiteDesconto = this.pedido.clientes[0].permite_desconto;
            // this.form.controls.idEndereco.setValue(this.pedido.clientes[0].cliente.enderecos.idenderecoerp);
            this.form.controls.formaPagamento.enable();
          } else {
            this.form.controls.formaPagamento.disable();
          }
          if (this.pedido.tipo.tipoFrete === 0) {
            this.form.controls.formaPagamento.enable();
          }
          this.recalculaDescontosAplicados();
        });
      }.bind(this),
      this.idPedidoDelete
    );
  }

  getCep(idEnderecoErp) {
    let cep = "";
    if (this.selectedCliente.idEnderecoErp == idEnderecoErp) {
      cep = this.selectedCliente.cep;
    } else {
      for (let i = 0; i < this.selectedCliente.enderecos.length; i++) {
        if (this.selectedCliente.enderecos[i].idEnderecoErp == idEnderecoErp) {
          cep = this.selectedCliente.enderecos[i].cep;
        }
      }
    }
    return cep;
  }

  selecionaCliente(c: any) {
    this.selectedCliente = c;
  }
  getSafeImageUrl() {
    // Certifique-se de qrCode.image_qrcode contém a string base64 da imagem
    if (this.qrCode.image_qrcode !== undefined) {
      const imageUrl = "data:image/png;base64," + this.qrCode.image_qrcode;
      return this.sanitizer.bypassSecurityTrustResourceUrl(imageUrl);
    }
  }

  savePedidoFilial() {
    if (this.pedidoService.loading) {
      return;
    }
    this.pedidoService.editFilial(
      this.pedido.filial.id,
      function (resp) {
        this.pedidoService.select(resp);
        this.notify(resp);
        this.toastService.success(
          this.pedido.filial.codigo + "- " + this.pedido.filial.descricao,
          this.SITE.labelFilial,
          { positionClass: "toast-bottom-left" }
        );
      }.bind(this)
    );
  }

  savePedidoTipo() {
    if (this.pedidoService.loading) {
      return;
    }
    this.pedidoService.editTipo(
      this.pedido.tipo.id,
      function (resp) {
        this.pedidoService.select(resp);
        this.notify(resp);
        this.toastService.success(
          this.pedido.tipo.tipo + " - " + this.pedido.tipo.descricao,
          this.SITE.labelPedidoTipo,
          { positionClass: "toast-bottom-left" }
        );
      }.bind(this)
    );
  }

  calculaFrete(cepDestino) {
    this.calculando = true;
    let element = document.getElementById("btn-retirar");
    element !== null ? (element.style.backgroundColor = "") : null;

    let element2 = document.getElementById("calc");
    element2 !== null ? (element.style.backgroundColor = "#1c5c46") : null;

    document.getElementById("receber") !== null
      ? (document.getElementById("receber").style.display = "")
      : null;
    document.getElementById("divfrete") !== null
      ? (document.getElementById("divfrete").style.display = "")
      : null;
    document.getElementById("retirar") !== null
      ? (document.getElementById("retirar").style.display = "none")
      : null;
    //document.getElementById('aviso').style.display = 'none';

    if (this.freteService.loading) return;
    if (cepDestino.length != 8) {
      Swal.fire(
        $localize`CEP`,
        $localize`Informe um número de CEP corretamente.`,
        "warning"
      );
      this.calculando = false;
      return;
    }

    let errorMsgFrete = "";
    let mapProdFrete = {};
    this.pedido.itens.forEach((i) => {
      if (
        !i.produtoPeso ||
        !i.produtoLargura ||
        !i.produtoAltura ||
        !i.produtoComprimento
      ) {
        mapProdFrete[i.produtoReferencia] = true;
      }
    });
    if (this.tipoFrete > 0) {
      this.form.controls.freteId.setValue("");
      this.form.controls.freteValor.setValue("");
      this.freteValor = 0;
      this.form.controls.freteDescr.setValue("");
      this.form.controls.freteCepDestino.setValue(cepDestino);
      this.fretes = { receber: [], retirar: [] };
    }
    // this.atualizaValores();

    if (errorMsgFrete) {
      Swal.fire({
        title: $localize`Frete não poderá ser calculado`,
        html: errorMsgFrete,
        icon: "warning",
        confirmButtonText: "Confirma",
      });
      this.calculando = false;
      this.errorFrete = true;
      //return;
    }

    let criterioVisualizacao = null;

    if (this.tipoFrete > 0 && this.currentFormaPagamento !== undefined) {
      this.freteService.getFretesAPIAgilb2b(
        this.pedido,
        criterioVisualizacao,
        cepDestino,
        this.valorTotal,
        this.errorFrete,
        function (resp) {
          this.switchReceber();
          this.fretes = resp;
          const receber = Array.isArray(resp?.receber) ? resp.receber : [];
          const selectedFrete = receber.find((f) => f?.id == this.pedido.frete);
          const fallbackFrete = receber.length ? receber[0] : undefined;
          const freteToApply = selectedFrete ?? fallbackFrete;

          if (!freteToApply) {
            this.form.controls.freteId.setValue("");
            this.form.controls.freteValor.setValue("");
            this.freteValor = 0;
            this.toastService.warning(
              $localize`Não foi possível selecionar o frete retornado pela API.`,
              $localize`Frete`,
              { positionClass: "toast-bottom-left" }
            );
            return;
          }

          this.form.controls.freteId.setValue(freteToApply.id);
          this.form.controls.freteValor.setValue(freteToApply.valor ?? 0);
          this.freteValor = freteToApply.valor ?? 0;
        }.bind(this),
        this.currentFormaPagamento
      );
    }
    this.calculando = false;
    this.retirar = false;
  }

  notify(pedido: Order) {
    this.firstOpen = true;
    this.error = false;
    this.formaPagamento = [];
    this.pedidoClientes = [];
    this.pedidoItens = [];
    this.pedidoItensQuantSum = 0;
    this.pedidoItensPrecoSum = 0;
    this.countPCDescFilial = 0;
    this.countPCAcresFilial = 0;
    this.subTotal = 0;
    this.valorTotal = 0;
    this.acrescimoTotal = 0;
    this.descontoFormaPagamento = 0;
    this.impostosTotal = 0;
    this.impostos = [];
    this.itens = [];
    this.checkErrorEstoqueBool = false;
    this.fretes = { receber: [], retirar: [] };
    this.files = [];
    this.freteShow = false;
    this.pedidoTiposUsuario = [];
    //this.showEditTipo = false;

    /////////
    //this.showEditFilial = false;
    this.fatalError = false;
    this.freteSalvoDescr = "";
    this.showFreteSum = false;
    this.errorFrete = false;
    this.tipoFrete = this.pedidoService.pedido.tipo.tipoFrete;
    this.uploadFile = this.pedidoService.pedido.tipo.uploadFile;

    //caso tenha mais que 01 cliente não será possível calcular frete
    // if (this.tipoFrete > 0) {
    //   if (pedido.clientes.length > 1) {
    //     Swal.fire(
    //       $localize`Pedido`,
    //       $localize`Mais de um cliente para realizar o frete. Por favor altere o tipo de pedido.`,
    //       "info"
    //     );
    //     this.fatalError = true;
    //   }
    // }

    //formulário de frete, carregando caso pedido esteja salvo
    let freteId = pedido["frete"] ? pedido["frete"] : "";
    let freteValor = pedido["freteValor"] ? pedido["freteValor"] + "" : "0";
    this.freteValor = pedido["freteValor"] ? pedido["freteValor"] : 0;
    this.freteCepDestino = pedido["freteCepDestino"]
      ? pedido["freteCepDestino"]
      : "";
    let freteDescr = pedido["freteDescr"] ? pedido["freteDescr"] : "";
    let freteNome = pedido["freteNome"] ? pedido["freteNome"] : "";
    let freteSobrenome = pedido["freteSobrenome"]
      ? pedido["freteSobrenome"]
      : "";
    let freteModalidade = "";
    if (pedido["freteModalidade"] === 0 || pedido["freteModalidade"]) {
      freteModalidade = pedido["freteModalidade"] + "";
    }
    this.freteSalvoDescr = freteDescr;

    //verificando se banco usa endereço padrão na entidade cliente e array em cliente.enderecos
    if (pedido.clientes[0].cliente.enderecos) {
      this.clienteIdErp = {};
      this.selectedCliente = pedido.clientes[0].cliente;
      for (let i = 0; i < pedido.clientes.length; i++) {
        this.clienteIdErp[pedido.clientes[i].cliente.id] =
          pedido.clientes[i].idEnderecoErp + "";
      }
      if (!pedido["freteCepDestino"]) {
        this.freteCepDestino = this.getCep(pedido.clientes[0].idEnderecoErp);
      }
    }

    //verificando o bloqueio do formulário
    let disabled = false;
    if (pedido.salvoCheckout) {
      disabled = true;
    }

    //iniciando formulário simples
    let idErp;
    if (pedido.clientes[0].cliente.enderecos[0]) {
      if (pedido.clientes[0].cliente.enderecos[0].idenderecoerp) {
        for (let i = 0; i < pedido.clientes[0].cliente.enderecos.length; i++) {
          if (pedido.clientes[0].cliente.enderecos[i].selecionado) {
            idErp =
              pedido.clientes[0].cliente.enderecos[i].idenderecoerp.toString();
          }
        }
      } else {
        for (let i = 0; i < pedido.clientes[0].cliente.enderecos.length; i++) {
          if (pedido.clientes[0].cliente.enderecos[i].selecionado) {
            idErp = pedido.clientes[0].cliente.enderecos[i].id.toString();
          }
        }
      }
    }
    let formObj: any = {
      formaPagamento: [
        {
          value: "",
          disabled:
            (disabled || this.QtdPedidoClienteSelected !== 1) &&
            this.tipoFrete > 0,
        },
        [Validators.required],
      ],
      tipoPagamento: [{ value: "", disabled: disabled }],
      observacao: [pedido.observacao],
      observacaoNota: [pedido.observacaoNota],
      numPedidoCliente: [""],
      cupom: [""],
      descontoPercent: [0],
      idEndereco: [""],
    };
    if (!pedido.clientes[0].cliente.enderecos[0]) {
      Swal.fire(
        $localize`Pedido`,
        $localize`Cliente sem endereço cadastrado ou endereço inválido`,
        "info"
      );
      return
    }

    //iniciando os tipos de frete, manual ou API
    if (this.tipoFrete == 1) {
      if (freteValor != "") {
        freteValor.replace(".", ",");
      }
      formObj["freteIdRetirar"] = ["0"];
      formObj["tipoFrete"] = ["1", [Validators.required]];
      formObj["freteDescr"] = [
        "Valor manual",
        // , [Validators.required]
      ];
      formObj["freteValor"] = [
        { value: freteValor, disabled: disabled },
        // ,[Validators.required]
      ];
      formObj["freteCepDestino"] = [
        {
          value: this.freteCepDestino,
          disabled: !pedido.tipo.permiteDigitacaoCep,
        },
        [Validators.required],
      ];
      if (pedido.tipo.modalidadeFreteCF) {
        formObj["freteModalidade"] = [
          { value: freteModalidade, disabled: disabled },
          [Validators.required],
        ];
      }
    } else if (this.tipoFrete == 2) {
      formObj["tipoFrete"] = ["2", [Validators.required]];
      formObj["freteIdRetirar"] = ["0"];
      formObj["freteId"] = [
        { value: freteId, disabled: disabled },
        [Validators.required],
      ];
      formObj["freteValor"] = [
        { value: freteValor, disabled: disabled },
        // ,[Validators.required]
      ];
      formObj["freteCepDestino"] = [
        {
          value: this.freteCepDestino,
          disabled: !pedido.tipo.permiteDigitacaoCep,
        },
        [Validators.required],
      ];
      formObj["freteDescr"] = [
        { value: freteDescr, disabled: disabled },
        // ,[Validators.required]
      ];
      formObj["freteNome"] = [{ value: freteNome, disabled: disabled }];
      formObj["freteSobrenome"] = [
        { value: freteSobrenome, disabled: disabled },
      ];
      if (pedido.tipo.modalidadeFreteCF) {
        formObj["freteModalidade"] = [
          { value: freteModalidade, disabled: disabled },
          // [Validators.required],
        ];
      }
    }

    this.form = this.formBuilder.group(formObj);

    const enderecos = this.selectedCliente?.enderecos || [];
    if (enderecos.length === 1) {
      const unico = enderecos[0];
      const idDefault = (unico.idenderecoerp ?? unico.id).toString();
      this.form.controls["idEndereco"].setValue(idDefault);

      // Opcional: calcular frete automaticamente
      // if (this.tipoFrete > 0 && !this.pedido.tipo.permiteDigitacaoCep && unico.cep) {
      //   this.calculaFrete(unico.cep); // chama PageCheckoutComponent.calculaFrete
      // }
    } else if (enderecos.length > 1) {
      const enderecoSelecionado = this.selectedCliente?.enderecos?.find(
        (e: any) => e.selecionado
      );
      if (enderecoSelecionado) {
        this.form.controls['idEndereco'].setValue(enderecoSelecionado.idenderecoerp.toString());
      }
    }

    this.pedido = pedido;
    this.subTotal = this.pedido.clientes.reduce(
      (acc, f) => acc + f.subtotal,
      0
    );
    this.valorTotal = this.pedido.total;
    this.maxDesconto = this.pedido.clientes[0].desconto_maximo;
    this.permiteDesconto = this.pedido.clientes[0].permite_desconto;
    this.acrescimoTotal = this.pedido.clientes.reduce(
      (acc, f) => acc + f.acrescimo,
      0
    );
    this.impostosTotal = this.pedido.clientes.reduce(
      (acc, f) => acc + f.impostos,
      0
    );
    this.impostos = this.getImpostArray(this.pedido.itens);
    this.countPCDescFilial = 0;
    this.countPCAcresFilial = 0;
    this.pedido.itens.forEach((i) => {
      this.itens.push(Object.assign({}, i));
    });
    this.pedido.clientes.map((val) => {
      this.pedidoClientes.push({
        cliente: val.cliente,
        quantidade: val.quantidade,
        acrescimo: 0,
        acrescimoPercent: 0,
        desconto: 0,
        descontoPercent: 0,
        politicasComerciaisDesc: 0,
        politicasComerciaisAcres: 0,
      });
    });

    if (this.pedido.clientes.length === 1) {
      this.pedidoClienteSelected = { todos: true };
      this.pedido.clientes.forEach(
        (pc) => (this.pedidoClienteSelected[pc.cliente["id"]] = true)
      );
      // this.form.controls.idEndereco.setValue(this.pedido.clientes[0].cliente.enderecos.idenderecoerp);
    } else {
      this.pedidoClienteSelected = { todos: false };
      this.pedido.clientes.forEach(
        (pc) => (this.pedidoClienteSelected[pc.cliente["id"]] = false)
      );
    }
    //consultando as formas de pagamento e tipos de pedido

    this.atualizaFormasPagamento(disabled);
    let end = this.pedido.clientes[0].cliente.enderecos.filter(e => e.selecionado === true)
    if(end.length === 0){
     end = this.pedido.clientes[0].cliente.enderecos
    }
    if(this.tipoFrete > 0) {
      this.form.controls.freteCepDestino.setValue(end[0].cep);
    }
    this.atualizaPedidoItens();
    this.pedidoService.atualizaPedido(pedido.id);
  }

  private atualizaFormasPagamento(disabled = false) {
    let cliente = [];
    for (let key of Object.keys(this.pedidoClienteSelected)) {
      if (this.pedidoClienteSelected[key] && key != "todos")
        cliente.push(parseInt(key));
    }
    this.pedidoService.getFormasPagamento(
      this.filtrados.length === 1
        ? this.filtrados[0].id
        : this.pedidoService.pedido.clientes[0].id,
      cliente,
      function (resp) {
        this.formaPagamento = resp;
        let formaPagamentoId = this.pedido["formaPagamento"]
          ? this.pedido["formaPagamento"]["codigo"]
          : "";
        this.form.controls.formaPagamento.setValue(formaPagamentoId);
        this.recalculaDescontosAplicados();
        this.changeFormaPagamento();
        this.recalculaDescontosAplicados();
        this.firstOpen = false;
        if (disabled && this.tipoFrete > 0) {
          this.form.controls.formaPagamento.disable();
        } else {
          if (
            Object.keys(this.pedidoClienteSelected).length <= 2 ||
            this.QtdPedidoClienteSelected === 1 ||
            this.tipoFrete === 0
          ) {
            this.form.controls.formaPagamento.enable();
          }
        }
      }.bind(this)
    );
    this.usuarioService.getPedidoTipos(
      function (resp) {
        this.pedidoTiposUsuario = resp;
      }.bind(this)
    );
  }
  onFileSelected(event: any): void {
    this.loadingUpload = true;
    event.preventDefault();
    const formData = new FormData();
    formData.append("file", event.target.files[0]);
    this.productService.importaProdutos(
      this.pedido.id,
      formData,
      function (resp) {
        if (resp.listaItensErro.length > 0) {
          for (let i = 0; i < resp.listaItensErro.length; i++) {
            this.toastService.error(
              "Erro ao incluir item: " + resp.listaItensErro[i].EAN
            );
          }
        }
        //this.notify(pedido);
        //this.pedidoService.refresh();
        this.notify(resp);
        this.pedidoService.select(resp);
        event.target.value = "";
        this.loadingUpload = false;
      }.bind(this),
      (err: any) => {
        event.target.value = "";
        this.loadingUpload = false;
        if (err._body) {
          Swal.fire(
            $localize`Produtos`,
            $localize`Erro no upload: ` + JSON.parse(err._body).detail,
            "error"
          );
        } else {
          Swal.fire(
            $localize`Produtos`,
            $localize`Algo deu errado. Tente novamente mais tarde`,
            "error"
          );
        }
      }
    );
  }

  private getImpostArray(itens: OrderItem[]) {
    return [
      {
        tipo: "Ipi",
        valor: itens.length
          ? itens
            .map((a) => {
              return a.imp_valoripi * a.quantidade;
            })
            .reduce((a, b) => {
              return a + b;
            })
          : 0,
      },
      {
        tipo: "St",
        valor: itens.length
          ? itens
            .map((a) => {
              return a.imp_valorsubst * a.quantidade;
            })
            .reduce((a, b) => {
              return a + b;
            })
          : 0,
      },
      {
        tipo: "Fcp-st",
        valor: itens.length
          ? itens
            .map((a) => {
              return a.imp_valorfcpst * a.quantidade;
            })
            .reduce((a, b) => {
              return a + b;
            })
          : 0,
      },
      {
        tipo: "Total Impostos",
        valor: itens.length
          ? itens
            .map((a) => {
              return a.imp_valorimposto * a.quantidade;
            })
            .reduce((a, b) => {
              return a + b;
            })
          : 0,
      },
    ];
  }

  onChangeDiscount(value) {
    this.tempDiscount = value;
  }

  private toNumber(value): number {
    const parsed = Number(value);
    return Number.isNaN(parsed) ? 0 : parsed;
  }

  private getBaseDesconto(): number {
    return Math.max(
      this.subTotal -
      this.descontoCupom -
      this.descontoFormaPagamento -
      this.descontoItens,
      0
    );
  }

  private atualizaDescontoAplicado(percentual: number) {
    this.descontoAplicado = (percentual * this.getBaseDesconto()) / 100;
    this.descontoPercent = percentual;
  }

  private recalculaCupomPercentual() {
    if (!this.cupomPercentualAplicado) return;

    const percentualCupom = this.toNumber(
      this.pedidoService.descontoPercentCupom
    );
    const baseCupom = Math.max(
      this.subTotal -
      this.descontoAplicado -
      this.descontoItens -
      this.descontoFormaPagamento,
      0
    );

    this.descontoCupom = (baseCupom * percentualCupom) / 100;
    this.pedidoService.descontoCupom = (this.subTotal * percentualCupom) / 100;
  }

  private recalculaDescontosAplicados() {
    this.recalculaCupomPercentual();

    if (!this.descontoManualAplicado) return;

    const percentual = this.toNumber(this.tempDiscount);
    this.atualizaDescontoAplicado(percentual);
  }

  applyDiscount() {
    let v: number = this.toNumber(this.tempDiscount);
    if (v > this.maxDesconto) {
      this.toastService.warning(
        $localize`Desconto máximo de ${this.maxDesconto}%`,
        $localize`Aprovação Pedido`
      );
      return;
    } else if (v < 0 || v > 100) {
      this.toastService.warning(
        $localize`Valor inválido`,
        $localize`Aprovação Pedido`
      );
      return;
    }
    this.descontoManualAplicado = v > 0;
    this.atualizaDescontoAplicado(v);
  }

  changeFormaPagamento() {
    this.fretes = { receber: [], retirar: [] };
    if (this.tipoFrete == 2 && !this.firstOpen) {
      this.form.controls.freteId.setValue("");
      this.form.controls.freteValor.setValue("");
      this.freteValor = 0;
      this.form.controls.freteDescr.setValue("");
      this.onFreteModalidade("2");
      this.freteSalvoDescr = "";
      this.errorFrete = false;
    }
    let proximoValor = 0;
    let fp = this.form.controls.formaPagamento.value;
    let politicas = [];
    let fpId = this.form.controls.formaPagamento.value;
    if (fpId !== "" && fpId !== undefined) {
      let fp = this.formaPagamento.filter(
        (f) => f.forma_pagamento_id == fpId
      )[0];
      if (fp !== undefined && fp.politicas) {
        politicas = fp.politicas;
      }
    }

    if (politicas.length > 0 && this.SITE.tipoPoliticaComercial == 1) {
      this.politicaComercial01(politicas);
    } else {
      this.descontoFormaPagamento = 0;
      this.acrescimoTotal = 0;
      this.descontoPercent = 0;
    }
    if (fp != "") {
      this.freteShow = true;
      this.currentFormaPagamento = this.formaPagamento.filter(
        (find) => find.forma_pagamento_id == fp
      )[0];
      if (this.currentFormaPagamento !== undefined) {
        this.cifPermited = this.currentFormaPagamento.tipo_frete === "CIF";
        this.fobPermited = this.currentFormaPagamento.tipo_frete === "FOB";
        proximoValor = this.currentFormaPagamento.frete_gratis;
        if (this.cifPermited) {
          this.onFreteModalidade("0");
        } else {
          this.onFreteModalidade("1");
        }
      }
    }

    // this.atualizaValores();
    if (this.form.controls.freteId) {
      this.form.controls.freteId.setValue(this.pedido.frete, {
        emitEvent: true,
      });
    }
    if (proximoValor > 0) {
      this.worningMessage = this.SITE.menssagemQuantoFaltaFreteGratis.replace(
        "$valor",
        "R$" + this.currencyPipe.transform(proximoValor, "", "")
      );
    }
    this.pedido.tipo.permiteDigitacaoCep || this.tipoFrete === 0
      ? null
      : this.calculaFrete(this.form.controls.freteCepDestino.value);
  }
  changeTipoPagamento() {
    let tp = this.form.controls.tipoPagamento.value;
    if (tp != "") {
      this.currentTipoPagamento = this.tipoPagamento.filter(
        (find) => find.id == tp
      )[0];
    }
  }
  setAviso() {
    document.getElementById("aviso").style.display = "none";
  }

  retornaNumero(num) {
    return num === "" ? 0 : parseFloat(num);
  }

  selectRetirar(id) {
    this.form.controls.freteId.setValue(id);
  }

  blockSpace(event: KeyboardEvent) {
    if (event.key === " ") {
      event.preventDefault();
    }
  }

  sanitizePaste(event: ClipboardEvent) {
    event.preventDefault();

    // Obtém o texto do clipboard e remove espaços
    const clipboardData = event.clipboardData?.getData("text") || "";
    const sanitizedText = clipboardData.replace(/\s+/g, "");

    // Atualiza o campo com o valor limpo
    this.cupom = sanitizedText;
  }
  politicaComercial01(politicas) {
    for (var i = 0; i < politicas.length; i++) {
      let tipo = politicas[i].tipo;
      let tipoGerador = politicas[i].tipogerador;
      let acerto = politicas[i].acerto;
      let gerador = politicas[i].gerador;
      let quantidade = politicas[i].quantidade;
      this.descontoPercent = acerto;

      if (tipoGerador == "FL") {
        //FILIAL
        if (
          tipo == "DESCONTO" &&
          ((this.pedido.filial.id == gerador &&
            this.pedido.quantidade >= quantidade) ||
            (this.pedido.filial.id == gerador && !quantidade) ||
            (!gerador && this.pedido.quantidade >= quantidade) ||
            (!gerador && !quantidade))
        ) {
          this.descontoFormaPagamento =
            ((this.pedido.subtotal -
              this.descontoAplicado -
              this.descontoCupom -
              this.descontoItens +
              this.impostosTotal) *
              acerto) /
            100;
        } else if (
          tipo == "ACRESCIMO" &&
          this.countPCAcresFilial == 0 &&
          ((this.pedido.filial.id == gerador &&
            this.pedido.quantidade >= quantidade) ||
            (this.pedido.filial.id == gerador && !quantidade) ||
            (!gerador && this.pedido.quantidade >= quantidade) ||
            (!gerador && !quantidade))
        ) {
          //this.acrescimoPercent += acerto;
          this.pedidoClientes.forEach((pc) => {
            pc.acrescimoPercent += acerto;
          });
          this.countPCAcresFilial++;
        }
      } else if (tipoGerador == "CL") {
        //CLIENTE
        this.pedidoClientes.forEach((pc) => {
          if (
            tipo == "DESCONTO" &&
            pc.politicasComerciaisDesc == 0 &&
            ((pc.cliente["id"] == gerador && pc.quantidade >= quantidade) ||
              (pc.cliente["id"] == gerador && !quantidade) ||
              (!gerador && pc.quantidade >= quantidade) ||
              (!gerador && !quantidade))
          ) {
            this.descontoFormaPagamento =
              ((this.pedido.subtotal -
                this.descontoAplicado -
                this.descontoCupom -
                this.descontoItens +
                this.impostosTotal) *
                acerto) /
              100;
            // pc.politicasComerciaisDesc++;
            //this.countPCClientes = true;
          } else if (
            tipo == "ACRESCIMO" &&
            pc.politicasComerciaisAcres == 0 &&
            ((pc.cliente["id"] == gerador && pc.quantidade >= quantidade) ||
              (pc.cliente["id"] == gerador && !quantidade) ||
              (!gerador && pc.quantidade >= quantidade) ||
              (!gerador && !quantidade))
          ) {
            pc.acrescimoPercent += acerto;
            pc.politicasComerciaisAcres++;
            //this.countPCClientes = true;
          }
        });
      }
    }
  }

  atualizaPedidoItens() {
    this.pedidoItens = [];
    this.pedidoItensQuantSum = 0;
    this.pedidoItensPrecoSum = 0;
    let mapClientes: { [key: string]: number } = {};
    let keys = Object.keys(this.pedidoClienteSelected).filter(
      (k) => k !== "todos"
    );

    // verifica se todos são false
    let todosFalse = keys.every((k) => !this.pedidoClienteSelected[k]);

    for (let key of keys) {
      if (todosFalse) {
        mapClientes[key] = 1;
      } else if (this.pedidoClienteSelected[key]) {
        mapClientes[key] = 1;
      }
    }
    let map: any;
    map = { itens: [], quant: 0, preco: 0, precoComImposto: 0, nome: "" };
    if (this.modo == 1) {
      map = this.pedidoService.mapaPedidoItensPorProduto(
        this.pedido.itens,
        mapClientes
      );
    } else {
      map = this.pedidoService.mapaPedidoItens(this.pedido.itens, mapClientes);
    }
    this.pedidoItens = map.itens;
    // .length === 0 ? this.pedido.itens : map.itens;
    this.pedidoItensQuantSum = map.quant;
    this.pedidoItensPrecoSum = map.preco;
    this.pedidoItensPrecoSumComImp = map.precoComImposto;
    this.recalculaDescontosAplicados();
    this.changeFormaPagamento();
    this.recalculaDescontosAplicados();
  }

  onDiscountChange(value: number) {
    if (value < 0) this.descontoPercent = 0;
    else if (value > 100) this.descontoPercent = 100;
    else this.descontoPercent = value;
  }
  changePedidoClienteSelectedTodos() {
    if (this.tipoFrete > 0) {
      this.form.controls.formaPagamento.disable();
    }
    this.QtdPedidoClienteSelected = this.pedido.clientes.length;
    if (this.pedidoClienteSelected.todos) {
      for (var i = 0; i < this.pedido.clientes.length; i++) {
        this.pedidoClienteSelected[this.pedido.clientes[i]["cliente"]["id"]] =
          true;
      }
    } else {
      for (var i = 0; i < this.pedido.clientes.length; i++) {
        this.pedidoClienteSelected[this.pedido.clientes[i]["cliente"]["id"]] =
          false;
      }
    }
    this.subTotal = this.pedido.clientes.reduce(
      (acc, f) => acc + f.subtotal,
      0
    );
    this.imposto = this.pedido.impostos;
    this.valorTotal = this.pedido.total;
    this.atualizaFormasPagamento();
    this.atualizaPedidoItens();
  }
  changePedidoClienteSelected() {
    this.pedidoClienteSelected.todos = true;
    for (var i = 0; i < this.pedido.clientes.length; i++) {
      if (
        !this.pedidoClienteSelected[this.pedido.clientes[i]["cliente"]["id"]]
      ) {
        this.pedidoClienteSelected.todos = false;
        break;
      }
    }
    this.filtrados = this.pedido.clientes.filter(
      (p) => this.pedidoClienteSelected[p.cliente.id]
    );
    if (this.filtrados.length === 0) {
      this.changePedidoClienteSelectedTodos();
      return;
    }
    this.selectedCliente = this.filtrados[0].cliente;

    this.QtdPedidoClienteSelected = this.filtrados.length;
    if (
      Object.keys(this.pedidoClienteSelected).length <= 3 &&
      this.tipoFrete === 0
    ) {
      this.form.controls.formaPagamento.enable();
    } else {
      this.form.controls.formaPagamento.disable();
    }
    if (this.filtrados.length > 0) {
      this.subTotal = this.filtrados.reduce((acc, f) => acc + f.subtotal, 0);
      this.impostosTotal = this.filtrados.reduce(
        (acc, f) => acc + f.impostos,
        0
      );
      this.maxDesconto = this.filtrados[0].desconto_maximo;
      this.permiteDesconto = this.filtrados[0].permite_desconto;
      this.imposto = this.filtrados.reduce((acc, f) => {
        Object.keys(f.imposto).forEach((key) => {
          acc[key] = (acc[key] || 0) + (f.imposto[key] || 0);
        });
        return acc;
      }, {} as any);
      this.valorTotal = this.filtrados.reduce((acc, f) => acc + f.total, 0);
    } else {
      this.subTotal = this.pedido.clientes.reduce(
        (acc, f) => acc + f.subtotal,
        0
      );
      this.imposto = this.pedido.impostos;
      this.valorTotal = this.pedido.total;
    }
    this.atualizaFormasPagamento();
    this.atualizaPedidoItens();
  }

  // checkQtdPedidoClienteSelected(){
  //   const trueCount =  Object.entries(this.pedidoClienteSelected)
  //   .filter(([key, value]) => key !== "todos" && value === true).length;
  //   return trueCount === 1
  // }

  onSubmit = () => {
    this.loadSubmit = true;
    const trueCount = Object.entries(this.pedidoClienteSelected).filter(
      ([key, value]) => key !== "todos" && value === true
    ).length;

    if (trueCount !== 1 && this.tipoFrete > 0) {
      this.toastService.error(
        $localize`Selecione somente um cliente`,
        $localize`Aprovação Pedido`
      );
      this.loadSubmit = false;
      return;
    }
    if (this.bloqueiaPedidos) {
      if (!this.verificaClienteBloqueado()) {
        this.loadSubmit = false;
        return;
      }
    }

    if (this.usaTipoPedido && this.form.controls.tipoPagamento.value === "") {
      this.toastService.error(
        $localize`Selecione um tipo de pagamento`,
        $localize`Aprovação Cliente`
      );
      this.loadSubmit = false;
      return;
    }
    if (
      this.currentFormaPagamento === undefined ||
      this.currentFormaPagamento === null
    ) {
      this.toastService.error(
        $localize`Selecione uma forma de pagamento`,
        $localize`Aprovação Pedido`
      );
      this.loadSubmit = false;
      return;
    }
    if (this.currentFormaPagamento.natureza === null) {
      if (
        this.limiteDisponivel <= this.valorTotal &&
        this.limiteDisponivel !== null
      ) {
        this.toastService.error(
          $localize`Seu limite de crédito disponível é R$ ${this.limiteDisponivel.toLocaleString(
            "pt-BR",
            {
              style: "currency",
              currency: "BRL",
            }
          )} .`,
          $localize`Aprovação Pedido`
        );
        this.loadSubmit = false;
        return;
      }
      if (!this.limiteValido && this.limiteCredito !== null) {
        this.toastService.error(
          $localize`Limite de crédito fora do prazo de validade`,
          $localize`Aprovação Pedido`
        );
        this.loadSubmit = false;
        return;
      }
    }
    this.pedido.clientes[0].idEnderecoErp = this.form.controls.idEndereco.value;
    // if (this.isPix() && !this.SITE.gera_pagamento_aprovacao) {
    //   this.getPix();
    // } else {
    this.finalizaPedido();
    // }
    this.loadSubmit = false;
    if (this.QtdPedidoClienteSelected !== 1 && this.tipoFrete > 0) {
      this.form.controls.formaPagamento.disable();
    }
    // this.notify()
    // this.QtdPedidoClienteSelected = 0
  };

  private verificaClienteBloqueado(): boolean {
    let clientesBloqueados = this.pedido.clientes.filter(
      (c) => c.cliente.bloqueiaPedidos && c.cliente.bloqueiaPedidos !== false
    );
    let f: any = false;
    if (clientesBloqueados.length) {
      let message = clientesBloqueados[0].cliente.nome;

      for (let i = 1; i < clientesBloqueados.length - 1; i++)
        message += ", " + clientesBloqueados[i].cliente.nome;

      if (clientesBloqueados.length > 1)
        message += ` e ${clientesBloqueados[clientesBloqueados.length - 1].cliente.nome
          }`;

      this.error = true;
      this.errorMsg = $localize`Cliente(s) ${message} com pendência financeira, não será possível finalizar a venda.`;
      return false;
    }

    return true;
  }

  removeCupom() {
    this.descontoCupom = 0;
    this.pedidoService.descontoCupom = 0;
    this.pedidoService.descontoPercentCupom = 0;
    this.cupomPercentualAplicado = false;
    this.idCupom = "";
    this.cupom = "";
    this.cupomAplicado = "";
  }

  aplicaCupom() {
    if (this.cupom === "") {
      this.toastService.warning(
        $localize`Insira um cupom válido`,
        $localize`Cupom`,
        { timeOut: 5000 }
      );
      return;
    }
    this.pedidoService.aplicaCupom(
      this.cupom,
      function (resp) {
        if (resp.valor_minimo_pedido > this.valorTotal) {
          this.toastService.warning(
            $localize`Valor minimo do pedido de R$ ${resp.valor_minimo_pedido.toLocaleString(
              "pt-BR",
              {
                style: "currency",
                currency: "BRL",
              }
            )} para aplicar Cupom`,
            $localize`Cupom`,
            { timeOut: 5000 }
          );
          return;
        }
        if (resp.tipo_cupom === "percentual") {
          this.cupomPercentualAplicado = true;
          this.descontoCupom =
            ((this.subTotal -
              this.descontoAplicado -
              this.descontoItens -
              this.descontoFormaPagamento) *
              resp.valor) /
            100;
          this.idCupom = resp.id_cupom;
          this.pedidoService.descontoCupom = (this.subTotal * resp.valor) / 100;
          this.pedidoService.descontoPercentCupom = resp.valor;
        } else {
          this.cupomPercentualAplicado = false;
          this.descontoCupom = resp.valor;
          this.pedidoService.descontoCupom = resp.valor;
          this.pedidoService.descontoPercentCupom =
            (resp.valor / this.subTotal) * 100;
          this.idCupom = resp.id_cupom;
        }
        this.cupomAplicado = this.cupom;
        this.toastService.success(
          $localize`Cupom aplicado com sucesso`,
          $localize`Cupom`,
          { timeOut: 5000 }
        );
      }.bind(this),
      function (resp) {
        if (resp.error) {
          this.toastService.warning(resp.error.detail, $localize`Cupom`, {
            timeOut: 5000,
          });
        } else {
          this.toastService.warning(
            $localize`Algo deu errado`,
            $localize`Cupom`,
            { timeOut: 5000 }
          );
        }
        this.cupom = "";
      }.bind(this)
    );
  }

  finalizaPedido() {
    this.error = false;
    this.errorMsg = "";
    // --- Validações iniciais --
    if (this.valorTotal < this.valorMinimoPedido) {
      this.error = true;
      this.errorMsg =
        $localize`Valor do pedido inferior ao mínimo estipulado de $` +
        this.valorMinimoPedido.toLocaleString("pt-BR", {
          style: "currency",
          currency: "BRL",
        }) +
        "!";
      return;
    }
    // if (this.pedido.itens.length < this.qtdMinimaItens) {
    //   this.error = true;
    //   this.errorMsg =
    //     $localize`Quantidade mínima de itens de ` +
    //     this.qtdMinimaItens +
    //     "!";
    //   return;
    // }
    if (this.checkErrorEstoqueBool) {
      this.error = true;
      this.errorMsg = "Confira o estoque dos produtos!";
      return;
    }
    if (!this.form.valid) {
      if (this.form.controls.formaPagamento.errors !== null) {
        this.toastService.error(
          $localize`Selecione uma forma de pagamento`,
          $localize`Aprovação Cliente`
        );
      }

      if (this.form.controls.freteId.errors !== null) {
        this.toastService.error(
          $localize`Selecione um tipo de frete`,
          $localize`Aprovação Cliente`
        );
      }
      return;
    }
    if (!(this.valorTotal > 0)) {
      this.error = true;
      this.errorMsg = "Valor total inválido!";
      return;
    }
    if (this.uploadFile == 1 && this.files.length == 0) {
      this.error = true;
      this.errorMsg = "Arquivo(s) do tipo PDF não informado(s)!";
      return;
    }

    // --- Montando valores do formulário ---
    let formValue = {
      ...this.form.getRawValue(),
      natureza: this.currentFormaPagamento.natureza,
    };
    if (this.clienteIdErp) {
      if (
        !this.pedidoService?.pedido?.clientes ||
        this.pedidoService.pedido.clientes.length === 0
      ) {
        this.toastService.error(
          'Algo deu errado. Tente novamente mais tarde.'
        );
        return;
      }

      this.pedidoService.pedido.clientes.forEach((pc) => {
        pc.idEnderecoErp = this.clienteIdErp?.[pc.cliente?.id];
      });
    }
    if (this.tipoFrete == 1) {
      formValue.freteValor = formValue.freteValor
        .replace(".", "")
        .replace(",", ".");
    }

    formValue.freteOferta = this.freteOferta;
    formValue.freteToken = this.freteToken;

    formValue.cupom = this.cupomAplicado;
    formValue.id_cupom = this.idCupom;
    formValue.valorCupom = this.descontoCupom;
    formValue.desconto = this.descontoFormaPagamento + this.descontoAplicado;
    // formValue.descontoPercent = this.form.controls.descontoPercent.value;
    formValue.descontoPercent = this.descontoPercent;
    formValue.tipoPedido = this.pedido.tipo.id;
    formValue.tabela = this.pedido.tabela.id;
    if (this.form.controls.idEndereco.value === "") {
      this.toastService.info(
        $localize`Selecione um endereço`,
        $localize`Endereço`,
        { timeOut: 4000 }
      );
      return;
    }
    // --- Se tipoFrete === 0, finaliza 1 pedido por cliente selecionado ---
    if (this.tipoFrete === 0) {
      let clientesSelecionados = this.pedido.clientes.filter(
        (p) => this.pedidoClienteSelected[p.cliente.id]
      );
      if (clientesSelecionados.length === 0) {
        clientesSelecionados = this.pedido.clientes;
      }

      clientesSelecionados.forEach((cliente) => {
        let itensCliente = this.itens.filter(
          (item) => item.cliente === cliente.cliente.id
        );

        let formCliente = {
          ...formValue,
          clientes: [cliente],
          impostos: cliente.impostos,
        };

        this.pedidoService.finalizaPedido(
          this.files,
          formCliente,
          itensCliente,
          (resp) => {
            if (resp.msg === "OK") {
              if (
                clientesSelecionados.length === this.pedido.clientes.length &&
                !this.isPix() &&
                !this.isCartaoCredito()
              ) {
                Swal.fire({
                  title: $localize`Pedido`,
                  text: $localize`Finalizado com sucesso para o cliente ${cliente.cliente.nome}`,
                  icon: "success",
                  confirmButtonText: "OK",
                }).then(() => {
                  this.router
                    .navigate(["/pedidos"], {
                      queryParams: { page: "EM_ANDAMENTO" },
                    })
                    .then(() => {
                      window.location.reload();
                    });
                });

                this.pedidoService.unSelectAndDeleteCheckout();
              } else if (this.isPix() && !this.SITE.gera_pagamento_aprovacao) {
                this.getPix();
              } else if (this.isCartaoCredito()) {
                this.formComp.Save();

                this.router
                  .navigate(["/pedidos"], {
                    queryParams: { page: "EM_ANDAMENTO" },
                  })
                  .then(() => {
                    window.location.reload();
                  });
                this.pedidoService.unSelectAndDeleteCheckout();
              } else {
                Swal.fire(
                  $localize`Pedido`,
                  $localize`Finalizado com sucesso para o cliente ${cliente.cliente.nome}`,
                  "success"
                )
                this.pedidoService.getPedidoId(this.pedido.id, (e) => {
                  this.pedidoService.select(e);
                  // this.notify(this.pedidoService.pedido);
                   this.router
                    .navigate(["/pedidos"], {
                      queryParams: { page: "EM_ANDAMENTO" },
                    })
                    .then(() => {
                      window.location.reload();
                    });
                })
              }
            }
          },
          (error) => this.trataErroFinalizacao(error)
        );
      });

      return;
    }

    // --- Fluxo normal (tipoFrete != 0) ---
    let itensFiltered = this.itens.filter(
      (item) => this.pedidoClienteSelected[item.cliente]
    );

    formValue.impostos = this.pedido.clientes.filter(
      (p) => this.pedidoClienteSelected[p.cliente.id]
    )[0].impostos;

    formValue.clientes = this.pedido.clientes.filter(
      (p) => this.pedidoClienteSelected[p.cliente.id]
    );
    if (this.form.valid && !this.pedidoService.loading) {
      this.pedidoService.finalizaPedido(
        this.files,
        formValue,
        itensFiltered,
        (resp) => this.trataSucessoFinalizacao(resp),
        (error) => this.trataErroFinalizacao(error)
      );
    }
  }

  // --- Funções auxiliares ---
  private trataSucessoFinalizacao(resp: any) {
    if (resp.msg == "OK") {
      if (this.isCartaoCredito()) {
        return null
      }
      else if (!this.isPix() || this.SITE.gera_pagamento_aprovacao) {
        Swal.fire({
          title: $localize`Pedido`,
          text: $localize`Finalizado com sucesso, em andamento!`,
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          this.QtdPedidoClienteSelected = 0;
          this.router
            .navigate(["/pedidos"], {
              queryParams: { page: "EM_ANDAMENTO" },
            })
            .then(() => {
              window.location.reload();
            });
        })
        this.pedidoService.unSelectAndDeleteCheckout();
      } else if (this.isPix() && !this.SITE.gera_pagamento_aprovacao) {
        this.getPix();
        this.pedidoService.unSelectAndDeleteCheckout();
        this.QtdPedidoClienteSelected = 0;
      } else {
        this.toastService.info(
          $localize`Aguardando pagamento`,
          $localize`Pedido finalizado`,
          { timeOut: 4000 }
        );
        this.pedidoService.unSelectAndDeleteCheckout();
        this.QtdPedidoClienteSelected = 0;
      }
    }
  }

  private trataErroFinalizacao(error: any) {
    if (this.tipoFrete > 0) {
      this.form.controls.formaPagamento.disable();
    }
    if (error.status == 403) {
      let msg = $localize`Usuário não autenticado`;
      this.toastService.info(msg, "", { timeOut: 4000 });
      this.router.navigate(["/login"]).then(() => {
        window.location.reload();
      });
    } else {
      let msg = error.error.detail;
      this.toastService.info(msg, "", { timeOut: 4000 });
    }
  }

  redirect() {
    Swal.fire({
      title: $localize`Pedido`,
      text: $localize`Finalizado com sucesso`,
      icon: "success",
      confirmButtonText: "OK",
    }).then(() => {
      this.router
        .navigate(["/pedidos"], {
          queryParams: { page: "EM_ANDAMENTO" },
        })
        .then(() => {
          window.location.reload();
        });
    });

    this.pedidoService.unSelectAndDeleteCheckout();
  }

  getLinkAprovaCliente(idPedidoCliente) {
    if (
      this.SITE.precoDivergenteTabelaMin != null &&
      this.SITE.precoDivergenteTabelaIdeal != null &&
      this.pedido.precoDivergenteStatus == 2
    ) {
      this.toastService.error(
        $localize`Preço divergente pendente`,
        $localize`Aprovação Cliente`
      );
      return;
    }

    if (!this.pedido.quantidade) {
      this.toastService.error(
        $localize`Pedido vazio`,
        $localize`Aprovação Cliente`
      );
      return;
    }

    this.pedidoService.getAprovaPedidoLink(
      idPedidoCliente,
      function (resp) {
        $("#inputLinkAprovaCliente").val(resp.link);
        let el = document.getElementById("inputLinkAprovaCliente") as any;
        el.select();
        el.setSelectionRange(0, 99999);
        document.execCommand("copy");
        this.toastService.success(
          $localize`Copiado para área de transferência`,
          $localize`Aprovação Cliente`
        );
      }.bind(this)
    );
  }

  onFreteModalidade(mod) {
    if (this.form.controls.freteModalidade)
      this.form.controls.freteModalidade.setValue(mod);

    // this.atualizaValores();
  }

  onFrete(id: string) {
    this.showFreteSum = true;
    function decide(id: string, fretes1: FreteApiType) {
      return fretes1.receber.find((frete) => frete.id == Number(id));
    }
    const frete = decide(id, this.fretes);
    //&& !frete.error
    // if (Number.parseInt(frete.id) > 0) {
    this.form.controls.freteId.setValue(frete.id + "");
    this.form.controls.freteValor.setValue(frete.valor);
    this.freteValor = frete.valor;
    let freteDescr = frete.label;
    if (frete.labelPrazo) {
      freteDescr += ", " + frete.labelPrazo;
    }
    if (frete.valor) {
      freteDescr += ", R$" + this.currencyPipe.transform(frete.valor, "", "");
    }
    if (frete.oferta) {
      this.freteOferta = frete.oferta;
    }
    if (frete.token) {
      this.freteToken = frete.token;
    }
    this.form.controls.freteDescr.setValue(freteDescr);
    if (
      this.form.controls.freteValor.value === null ||
      this.form.controls.freteValor.value === 0 ||
      this.form.controls.freteValor.value === undefined
    ) {
      this.showFreteSum = false;
    }
    // this.atualizaValores();
    // }
  }

  onFreteRetirar(id: string) {
    function decide(id: string, fretes1: FreteApiType) {
      return fretes1.retirar.find((frete) => frete.id == Number(id));
    }
    const frete = decide(id, this.fretes);

    //&& !frete.error
    if (frete.id > 0) {
      this.form.controls.freteId.setValue(frete.id + "");
      this.form.controls.freteValor.setValue(frete.valor);
      this.freteValor = frete.valor;
      let freteDescr = frete.label;
      if (frete.labelPrazo) {
        freteDescr += ", " + frete.labelPrazo;
      }
      if (frete.valor) {
        freteDescr += ", R$" + this.currencyPipe.transform(frete.valor, "", "");
      }
      if (frete.oferta) {
        this.freteOferta = frete.oferta;
      }
      if (frete.token) {
        this.freteToken = frete.token;
      }
      this.form.controls.freteDescr.setValue(freteDescr);
      // this.atualizaValores();
    }
  }

  maskMoney(e) {
    let v = e.target.value;
    v = v.replace(/\D/g, "");
    v = v.replace(/[0-9]{12}/, "inválido");
    v = v.replace(/(\d{1})(\d{8})$/, "$1.$2");
    v = v.replace(/(\d{1})(\d{5})$/, "$1.$2");
    v = v.replace(/(\d{1})(\d{1,2})$/, "$1,$2");
    e.target.value = v;
    this.form.controls.freteValor.setValue(v);
    this.freteValor = v;
  }

  maskMoneyBlur() {
    // this.atualizaValores();
  }

  removeItemModo2() {
    if (!this.idDeleteModo2) return;

    this.pedidoService.codigoBarrasDel(
      this.pedido.id,
      this.idDeleteModo2,
      (resp) => {
        this.notify(resp);
        this.pedido = resp;
        this.pedidoService.select(resp);
        this.recalculaDescontosAplicados();
        this.toastService.success($localize`Item removido!`);

        // ❗ 1. Desfoca o botão "Ok" antes de fechar
        (document.activeElement as HTMLElement)?.blur();

        // ❗ 2. Fecha a modal corretamente
        const modal = document.getElementById("confirmDelModalModo2");
        if (modal) {
          ($(modal) as any).modal("hide");
        }
      }
    );
  }

  checkErrorEstoque(item) {
    if (item.quantidade > item.estoque) {
      this.checkErrorEstoqueBool = true;
    }
    return item.quantidade > item.estoque;
  }

  getPix() {
    if (this.checkErrorEstoqueBool) {
      this.error = true;
      this.errorMsg = "Confira o estoque dos produtos!";
      return;
    }
    this.usuarioService.getPix(
      {
        pedido_cliente: this.pedidoService.pedido.clientes[0].id,
      },
      function (resp) {
        this.qrCode = resp;
        $("#pixModal").modal("show");
        // this.finalizaPedido();
      }.bind(this),
      function (resp) {
        this.toastService.error(
          $localize`Tente novamente mais tarde`,
          $localize`Erro ao Gerar link de pagamento`
        );
      }.bind(this)
    );
  }
  confirmDel(item) {
    this.idDelete = item.produto;
    this.idPedidoDelete = item.pedidocliente_id;
  }

  confirmDelModo2(item) {
    this.idDeleteModo2 = item.id;
    this.idPedidoDelete = item.pedidocliente_id;
  }

  isCartaoCredito() {
    return (
      this.currentFormaPagamento &&
      this.currentFormaPagamento.natureza === "102"
    );
  }

  isPix() {
    return (
      this.currentFormaPagamento &&
      this.currentFormaPagamento.natureza === "002"
    );
  }

  copyLink(link) {
    // const link = `${window.location.origin}/produto`;
    navigator.clipboard
      .writeText(link)
      .then(() => {
        this.toastService.success(
          $localize`Link copiado com sucesso para a área de transferência`,
          $localize`Produto`,
          {
            positionClass: "toast-bottom-left",
          }
        );
      })
      .catch((err) => {
        this.toastService.warning(
          $localize`Erro ao copiar link para a área de transferência`,
          $localize`Produto`,
          {
            positionClass: "toast-bottom-left",
          }
        );
      });
  }

  mostrarTabela() {
    let element = document.getElementById("btn-retirar");
    let element2 = document.getElementById("calc");
    document.getElementById("retirar").style.display = "";
    document.getElementById("receber").style.display = "none";
    element.style.backgroundColor = "#1c5c46";
    element2.style.backgroundColor = "";
    this.retirar = true;
    this.form.controls.freteValor.setValue("");
    this.freteValor = 0;
    // this.form.controls.formaPagamento.setValue('')
    // this.form.controls.freteId.setValue("");
    // this.atualizaValores();
  }

  switchReceber() {
    let element = document.getElementById("btn-retirar");
    element !== null ? (element.style.backgroundColor = "") : null;

    let element2 = document.getElementById("calc");
    element2 !== null ? (element.style.backgroundColor = "#1c5c46") : null;

    document.getElementById("receber") !== null
      ? (document.getElementById("receber").style.display = "")
      : null;
    document.getElementById("divfrete") !== null
      ? (document.getElementById("divfrete").style.display = "")
      : null;
    document.getElementById("retirar") !== null
      ? (document.getElementById("retirar").style.display = "none")
      : null;
    this.retirar = false;
    // this.form.controls.freteId.setValue("");
  }

  closeModal() {
    // Remove o foco ANTES de fechar
    (document.activeElement as HTMLElement)?.blur();

    const modal = document.getElementById("confirmDelModalModo2");
    if (modal) {
      // Bootstrap 4
      ($(modal) as any).modal("hide");
    }
  }

  onSubmitCreditCard = (): Promise<any> => {
    this.loadSubmit = true;

    return new Promise((resolve, reject) => {
      try {
        const trueCount = Object.entries(this.pedidoClienteSelected).filter(
          ([key, value]) => key !== "todos" && value === true
        ).length;

        if (trueCount !== 1 && this.tipoFrete > 0) {
          this.toastService.error(
            $localize`Selecione somente um cliente`,
            $localize`Aprovação Pedido`
          );
          this.loadSubmit = false;
          return reject(new Error("Selecione somente um cliente"));
        }

        if (this.bloqueiaPedidos) {
          if (!this.verificaClienteBloqueado()) {
            this.loadSubmit = false;
            return reject(new Error("Cliente bloqueado"));
          }
        }

        if (
          this.usaTipoPedido &&
          this.form.controls.tipoPagamento.value === ""
        ) {
          this.toastService.error(
            $localize`Selecione um tipo de pagamento`,
            $localize`Aprovação Cliente`
          );
          this.loadSubmit = false;
          return reject(new Error("Selecione um tipo de pagamento"));
        }

        if (
          this.currentFormaPagamento === undefined ||
          this.currentFormaPagamento === null
        ) {
          this.toastService.error(
            $localize`Selecione uma forma de pagamento`,
            $localize`Aprovação Pedido`
          );
          this.loadSubmit = false;
          return reject(new Error("Selecione uma forma de pagamento"));
        }

        if (this.currentFormaPagamento.natureza === null) {
          if (
            this.limiteDisponivel <= this.valorTotal &&
            this.limiteDisponivel !== null
          ) {
            this.toastService.error(
              $localize`Seu limite de crédito disponível é R$ ${this.limiteDisponivel.toLocaleString(
                "pt-BR",
                {
                  style: "currency",
                  currency: "BRL",
                }
              )} .`,
              $localize`Aprovação Pedido`
            );
            this.loadSubmit = false;
            return reject(new Error("Limite insuficiente"));
          }
          if (!this.limiteValido && this.limiteCredito !== null) {
            this.toastService.error(
              $localize`Limite de crédito fora do prazo de validade`,
              $localize`Aprovação Pedido`
            );
            this.loadSubmit = false;
            return reject(new Error("Limite fora do prazo"));
          }
        }

        // prepara idEnderecoErp
        this.pedido.clientes[0].idEnderecoErp =
          this.form.controls.idEndereco.value;

        // --- Montando valores do formulário (mesma lógica de finalizaPedido) ---
        let formValue = {
          ...this.form.getRawValue(),
          natureza: this.currentFormaPagamento.natureza,
        };
        if (this.clienteIdErp) {
          this.pedidoService.pedido.clientes.forEach((pc) => {
            pc.idEnderecoErp = this.clienteIdErp[pc.cliente.id];
          });
        }
        if (this.tipoFrete == 1) {
          formValue.freteValor = formValue.freteValor
            .replace(".", "")
            .replace(",", ".");
        }

        formValue.freteOferta = this.freteOferta;
        formValue.freteToken = this.freteToken;

        formValue.cupom = this.cupomAplicado;
        formValue.id_cupom = this.idCupom;
        formValue.valorCupom = this.descontoCupom;
        formValue.desconto =
          this.descontoFormaPagamento + this.descontoAplicado;
        formValue.descontoPercent = this.descontoPercent;
        formValue.tipoPedido = this.pedido.tipo.id;
        formValue.tabela = this.pedido.tabela.id;

        if (this.form.controls.idEndereco.value === "") {
          this.toastService.info(
            $localize`Selecione um endereço`,
            $localize`Endereço`,
            { timeOut: 4000 }
          );
          this.loadSubmit = false;
        }

        // --- Se tipoFrete === 0, finaliza 1 pedido por cliente selecionado ---
        if (this.tipoFrete === 0) {
          let clientesSelecionados = this.pedido.clientes.filter(
            (p) => this.pedidoClienteSelected[p.cliente.id]
          );
          if (clientesSelecionados.length === 0) {
            clientesSelecionados = this.pedido.clientes;
          }

          const promises = clientesSelecionados.map((cliente) => {
            return new Promise((resCliente, rejCliente) => {
              let itensCliente = this.itens.filter(
                (item) => item.cliente === cliente.cliente.id
              );

              let formCliente = {
                ...formValue,
                clientes: [cliente],
                impostos: cliente.impostos,
              };

              this.pedidoService.finalizaPedido(
                this.files,
                formCliente,
                itensCliente,
                (resp) => {
                  if (resp && resp.msg === "OK") {
                    // replicando o comportamento original quando OK (mostra swal, navega ou chama getPix etc.)
                    if (
                      clientesSelecionados.length ===
                      this.pedido.clientes.length &&
                      !this.isPix() &&
                      !this.isCartaoCredito()
                    ) {
                      Swal.fire({
                        title: $localize`Pedido`,
                        text: $localize`Finalizado com sucesso para o cliente ${cliente.cliente.nome}`,
                        icon: "success",
                        confirmButtonText: "OK",
                      }).then(() => {
                        this.router
                          .navigate(["/pedidos"], {
                            queryParams: { page: "EM_ANDAMENTO" },
                          })
                          .then(() => {
                            window.location.reload();
                          });
                      });
                      this.pedidoService.unSelectAndDeleteCheckout();
                    } else if (
                      this.isPix() &&
                      !this.SITE.gera_pagamento_aprovacao
                    ) {
                      this.getPix();
                    } else if (this.isCartaoCredito()) {
                      // deixamos a responsabilidade do Save() chamar .Save() do form de cartão, se necessário
                      // aqui apenas resolvemos
                      this.formComp.Save?.();

                      this.router.navigate(["/pedidos"], { queryParams: { page: "EM_ANDAMENTO" } }).then(() => {
                        window.location.reload();
                      });
                      this.pedidoService.unSelectAndDeleteCheckout();
                    } else {
                      Swal.fire(
                        $localize`Pedido`,
                        $localize`Finalizado com sucesso para o cliente ${cliente.cliente.nome}`,
                        "success"
                      );
                      this.pedidoService.getPedidoId(this.pedido.id, (e) => {
                        this.pedidoService.select(e);
                        this.notify(this.pedidoService.pedido);
                      });
                    }

                    resCliente(resp);
                  } else {
                    rejCliente(
                      resp || new Error("Resposta inválida do servidor")
                    );
                  }
                },
                (error) => {
                  this.trataErroFinalizacao(error);
                  rejCliente(error);
                }
              );
            });
          });

          // aguarda todas as finalizações por cliente
          Promise.all(promises)
            .then((results) => {
              this.loadSubmit = false;
              resolve(results);
            })
            .catch((err) => {
              this.loadSubmit = false;
              reject(err);
            });

          return;
        }

        // --- Fluxo normal (tipoFrete != 0) ---
        let itensFiltered = this.itens.filter(
          (item) => this.pedidoClienteSelected[item.cliente]
        );

        formValue.impostos = this.pedido.clientes.filter(
          (p) => this.pedidoClienteSelected[p.cliente.id]
        )[0].impostos;

        formValue.clientes = this.pedido.clientes.filter(
          (p) => this.pedidoClienteSelected[p.cliente.id]
        );

        if (!this.form.valid) {
          if (this.form.controls.formaPagamento.errors !== null) {
            this.toastService.error(
              $localize`Selecione uma forma de pagamento`,
              $localize`Aprovação Cliente`
            );
          }

          if (this.form.controls.freteId.errors !== null) {
            this.toastService.error(
              $localize`Selecione um tipo de frete`,
              $localize`Aprovação Cliente`
            );
          }
          this.loadSubmit = false;
          return reject(new Error("Formulário inválido"));
        }

        if (this.form.valid && !this.pedidoService.loading) {
          this.pedidoService.finalizaPedido(
            this.files,
            formValue,
            itensFiltered,
            (resp) => {
              // sucesso da finalização normal
              this.loadSubmit = false;
              // mantenha o comportamento original de trataSucessoFinalizacao se necessário:
              this.trataSucessoFinalizacao?.apply(this, [resp]);
              resolve(resp);
            },
            (error) => {
              this.loadSubmit = false;
              this.trataErroFinalizacao(error);
              reject(error);
            }
          );
        } else {
          this.loadSubmit = false;
          reject(new Error("Pedido em processamento ou formulário inválido"));
        }
      } catch (err) {
        this.loadSubmit = false;
        reject(err);
      }
    });
  };
}
